import React 				from 'react';
import PropTypes 			from 'prop-types';
import BLComponent			from '../core/_BLComponent.jsx';

import ModalFrame from '../common/_ModalFrame.jsx';


export default class BuildingInstructionsModalWithDownload extends BLComponent {
	constructor(props) {
		super(props);

		this.state = {
			instructionsModalPage: 1
		}
	}

	render() {
		const {fileSize} = this.props;

		return (
			<ModalFrame classes={`building-instructions-modal building-instructions-modal--page-${this.state.instructionsModalPage}`} closeFunc={() => this.props.closeFunc()}>
				<button className="btn btn--blank building-instructions-modal__close text--xl-title" onClick={() => this.props.closeFunc()}><i className="far fa-times modal__close"/></button>
				{this.state.instructionsModalPage == 1 ?
					<div className="building-instructions-modal__content">
						<div className="building-instructions-modal__main building-instructions-modal__main--first">
							<h2 className="building-instructions-modal__title text--xl-title">BrickLink Designer Program Building Instructions</h2>
							<div className="building-instructions-modal__first">
								<div className="building-instructions-modal__first-main">
									<p className="l-margin-bottom--l">BrickLink Designer Program sets will feature digital building instructions provided by the LEGO® Builder app. The app lets you zoom, rotate and view your model in 3D and ghost view mode to see how far you’ve come and what part you’re in the process of building. The LEGO Builder app is great at keeping track of complex builds and makes it easy to save your building steps online.</p>
									<section className="building-instructions-modal__pdf">
										<div className="building-instructions-modal__pdf-image">
											<img src={"//" + blapp.config.getHost( "static2" ) + "/img/bdp/building-modal/download-pdf.svg"}/>
										</div>
										<div>
											<strong>Prefer printable PDF to digital instructions?</strong>
											<p className="l-margin-bottom">The PDF building instructions for this set is now available to download.</p>
											<button onClick={() => this.triggerPDF()} className="btn btn--link text--bold text--underline">Download instructions</button>
											<small className="text-color--primaryBlue l-block">{(fileSize/1048576).toFixed(2)} MB</small>
										</div>
									</section>
								</div>
								
								<div className="building-instructions-modal__first-app-container">
									<div className="building-instructions-modal__first-app-image">
								  	<img className="l-block" src={"//" + blapp.config.getHost( "static2" ) + "/img/bdp/building-modal/devices_desktop-tall.png"} alt="LEGO&reg; Builder app on iPad and iPhone screens"/>
									</div>
									<div className="building-instructions-modal__first-apps">
										<strong className="l-margin-bottom--sm l-block">Download LEGO Builder app from:</strong>
										<div className="building-instructions-modal__first-apps-list">
											<a className="building-instructions-modal__first-app-item" href="https://apps.apple.com/us/app/lego-building-instructions/id1486159728" target="_blank">
												<img src={"//" + blapp.config.getHost( "static2" ) + "/img/bdp/building-modal/badge_apple.svg"} alt="Download on the Apple App Store"/>
											</a>
											<a className="building-instructions-modal__first-app-item" href="https://play.google.com/store/apps/details?id=com.lego.legobuildinginstructions" target="_blank">
												<img src={"//" + blapp.config.getHost( "static2" ) + "/img/bdp/building-modal/badge_google.svg"} alt="Get it on Google Play"/>
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				:
					<div className="building-instructions-modal__content">
						<div className="building-instructions-modal__main">
							<h2 className="building-instructions-modal__title building-instructions-modal__title--page-2 text--xl-title">Get building instructions for your set using the app</h2>
							
							<div className="building-instructions-modal__second">
								<div className="building-instructions-modal__second-main">
									<div className="building-instructions-modal__install-item">
										<div className="building-instructions-modal__install-image building-instructions-modal__install-image--step-1">
											<img src={"//" + blapp.config.getHost( "static2" ) + "/img/bdp/building-modal/step-1.png"} alt="Download LEGO Builder app"/>
										</div>
										<div className="building-instructions-modal__install-content">
											<span className="building-instructions-modal__install-step">1</span>
											<p>Download LEGO Builder app</p>
										</div>
									</div>
									<div className="building-instructions-modal__install-item">
										<div className="building-instructions-modal__install-image building-instructions-modal__install-image--step-2">
											<img src={"//" + blapp.config.getHost( "static2" ) + "/img/bdp/building-modal/step-2.png"} alt="Type the set name or number in the search bar OR tap the QR code icon"/>
										</div>
										<div className="building-instructions-modal__install-content">
											<span className="building-instructions-modal__install-step">2</span>
											<p>Type the set name or number in the search bar OR tap the QR code icon</p>
										</div>
									</div>
									<div className="building-instructions-modal__install-item">
										<div className="building-instructions-modal__install-image building-instructions-modal__install-image--step-3">
											<img src={"//" + blapp.config.getHost( "static2" ) + "/img/bdp/building-modal/step-3.png"} alt="Scan QR code on box insert"/>
										</div>
										<div className="building-instructions-modal__install-content">
											<span className="building-instructions-modal__install-step">3</span>
											<p>Scan QR code on box insert</p>
										</div>
									</div>
								</div>
								<div className="building-instructions-modal__install-foot">
									<p className="l-margin-bottom--sm text--note">Check for compatibility/Kompatibilit t prüfen/V rifier la compatibilit/Controlla la compatibilit/Comprueba tu compatibilidad/Verificar a compatibilidade/Ellenőrizd a kompatibilit st Pārbaudīt saderību/检查兼容性</p>
									<p className="text--small"><strong><a href="https://www.lego.com/devicecheck" target="_blank" className="text-color--black">LEGO.com/devicecheck</a></strong></p>
								</div>
							</div>
						</div>
					</div>
				}

				<div className="building-instructions-modal__footer">
					<ul className="slick-dots l-margin--null">
						<li className={this.state.instructionsModalPage == 1 ? 'slick-active' : ''}><button onClick={() => this.setState({instructionsModalPage: 1})}>1</button></li>
						<li className={this.state.instructionsModalPage == 2 ? 'slick-active' : ''}><button onClick={() => this.setState({instructionsModalPage: 2})}>2</button></li>
					</ul>
					{this.state.instructionsModalPage == 1 ? 
						<button className="btn btn--wide btn--cta text--bold building-instructions-modal__footer-next" onClick={() => this.setState({instructionsModalPage: 2})}>How to use LEGO Builder<i className="fas fa-long-arrow-right l-margin-left--sm"/></button>
					:
						<div className="building-instructions-modal__footer-btn-group">
							<button className="btn btn--wide l-margin-right--sm text--no-wrap" onClick={() => this.setState({instructionsModalPage: 1})}><i className="fas fa-long-arrow-left l-margin-right--sm"/>Previous</button>
							<button className="btn btn--wide btn--cta text--bold l-margin-left--sm" onClick={() => this.setState({instructionsModalPage: 2})}>Done</button>
						</div>
					}
				</div>
			</ModalFrame>
		);
	}

	triggerPDF() {
		const {pdfUrl, idModel} = this.props;
		console.log(this.props);
		blapp.track.trackGeneral( 10101, idModel );
		window.open(pdfUrl, '_blank');
	}
}